import { createAction } from 'redux-actions'

const prefix = 'plugin/device:'

export const UPDATE_SCREEN_TYPE = `${prefix} Update screen type`
export const SET_BROWSER_INITIALIZED = `${prefix} Browser screen type watcher loaded`

export const updateScreenType = createAction(UPDATE_SCREEN_TYPE)
export const setBrowserInitialized = createAction(SET_BROWSER_INITIALIZED)
